import SubCategoryNavBarDesktop from '../components/SubCategoryNavBarDesktop';
import { connect } from 'react-redux';

const SubCategoryNavBarDesktopComponent = connect((state) => state)(SubCategoryNavBarDesktop);

export default SubCategoryNavBarDesktopComponent;